import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { LoginProvider } from '../../providers/login/login';
import { ToastProvider } from '../../providers/toast/toast';
import { SocialSharing } from '@ionic-native/social-sharing';

@IonicPage()
@Component({
  selector: 'page-referral',
  templateUrl: 'referral.html',
})
export class ReferralPage {

  loginDetails = {};
  passCode = {'code':'',"phone_no":'','contact_name':'','site_name':'', 'data': { 'email':'','additional_information':'' } };
  loading = false;
  showPage = 'form';
  referralList : any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    private storage: Storage,
    private loginProvider:LoginProvider,
    private toast: ToastProvider,
    private socialSharing: SocialSharing,
  ) {

    // this.referralList = [ {'mobile_no':'9015372248'},{'mobile_no':'9087656789'}]
    this.storage.get("loginDetails").then(val => {
      console.log(val);
      this.loginDetails = val;
      console.log(this.loginDetails);
      this.getPassCode(this.loginDetails)
    });
  }


  getPassCode(loginDetails) {
    this.passCode['code'] = loginDetails['societyId'] + '_' + loginDetails['id'];
    this.passCode['site_name'] = `Refer By-${loginDetails['society_name']}`;
    console.log(this.passCode, "---passcode");
  }


  addLeads(leadData) {
    this.loading = true;
    this.loginProvider.addReferral(leadData).then(val=>{
      this.loading = false;
        if(val && val.data && val.status =='success'){
          this.toast.presentToast(val.message );
          this.referralHistory();
          this.changeView('history');
           }else{
            this.toast.presentToast(val.message );
           }
    })

  }



  referralHistory(){
  this.loginProvider.getReferral(this.loginDetails['id']).then(val => {
    if(val && val.data && val.status == 'success'){
        this.referralList = val.data;
        this.referralList.reverse();
    }else{
      this.toast.presentToast(val.message );
    }
  })
  }

  changeView(view){
    this.showPage = view;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReferralPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/referral/referral.ts